import {Division, PositionNote} from "src/modules/playable/models/Division";
import {HandType} from "src/modules/global/types/GlobalTypes";
import {Note, NoteStatus} from "../../../playable/models/Note";

interface KeyNote {
  duration: number|null
  finger: number|null
  hand: HandType|'none'
  noteStatus: number
}

const emptyNote: KeyNote =  {
  duration: null,
  finger: null,
  hand: 'none',
  noteStatus: 0,
}

export default class Key {
  constructor(division: Division | null, isActive: boolean, inRange: boolean, keyData: any, isHighlighted : boolean) {
    this.currentNote = division?.currentHandprint.find((note) => note.key === keyData.id) ?? emptyNote;
    this.position = division?.position.find((position) => position.key === keyData.id) ?? emptyNote;
    this.nextNote = division?.nextHandprint.find((note) => note.key === keyData.id) ?? emptyNote;
    this.isActive = isActive;
    this.inRange = inRange;
    this.isHighlighted = isHighlighted;

    this.type = keyData.type;
    this.id = keyData.id;
    this.zone = keyData.zone;
    this.numBlackKeysBefore = keyData.numBlackKeysBefore;
  }

  /* Key note */
  currentNote: KeyNote|Note;
  position: KeyNote|PositionNote;
  nextNote: KeyNote|Note;
  isActive: boolean;
  inRange: boolean;
  isHighlighted: boolean;

  /* Key data */
  id: number;
  zone: string|null;
  type: string;
  numBlackKeysBefore: number;

  // TODO: Check if it can be simplified since currentNote is nullable
  public shouldDisplayCurrentFinger() {
    return this.currentNote.finger && this.currentNote.noteStatus > NoteStatus.OFF
  }

  // TODO: Check if it can be simplified since position is nullable
  public shouldDisplayPositionFinger() {
    return this.position.finger
       && (this.currentNote.finger === undefined || this.currentNote.noteStatus === NoteStatus.OFF)
  }
}
